<!-- ScorePHQ9.vue -->
<template>
  <v-card>
    <v-card-title>{{ $t('scales.gad7.title') }}</v-card-title>
    <v-card-text>      

      <!--Scores-->
      <div class="d-flex flex-row align-center mb-2" v-for="(scoreValue, scoreName) in scale.scores">
        <div class="d-flex flex-column mr-2">
          <div class="font-weight-light text-center">{{ $t('scales.gad7.score') }}</div>
          <div class="font-weight-bold text-center">{{ scoreName }} : {{ scoreValue.raw.value }} / {{ scoreValue.raw.max }} </div>
        </div>
        <CircularProgressComponent
          :value="scoreValue.raw.value"
          :max="scoreValue.raw.max"
          :color="getColor(scoreValue.raw.color)"
        />
      </div>

      <p class="mt-4">{{ $t('scales.gad7.interpretation') }}</p>
      <v-list>
        <v-list-item
          v-for="(item, index) in interpretations"
          :key="index"
          :title="typeof item === 'string' ? item : item.title"
          class="text-wrap"
        ></v-list-item>
      </v-list>

      <!--Individual answers-->
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ $t('scales.gad7.answers') }}
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-list lines="one">
              <v-list-item
                v-for="item, idx in scale.items"
                :key="idx"
                :title="(idx+1) + '. ' + item.text"
                :subtitle="answerText(scale.answers[idx])"
              ></v-list-item>
            </v-list>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>

    </v-card-text>
  </v-card>
</template>

<script>
import {getColor} from '@/utils/scales.js';
import CircularProgressComponent from '@/components/common/CircularProgressComponent.vue';

export default {
  name: 'ScoreGAD7',
  components: {
    CircularProgressComponent
  },
  data() {
    return {
      scale_id: 'gad7'
    }
  },
  props: {
    scale: {
      type: Object,
      required: true
    },
  },
  computed: {
    totalScore() {
      return this.scale.scores.total.raw;
    },
    interpretations() {
      return this.scale.interpretations;
    },

    severityColor() {
      const colors = {
        'Minimal': 'green',
        'Mild': 'yellow',
        'Moderate': 'orange',
        'Moderately Severe': 'deep-orange',
        'Severe': 'red'
      };
      return colors['Minimal'];
    },

    // interpretationText() {
    //   // Detailed clinical interpretation based on score
    //   const texts = {
    //     'Minimal': 'Minimal or no depression symptoms.',
    //     'Mild': 'Mild depression. Watchful waiting, repeat PHQ-9 at follow-up.',
    //     // ... etc
    //   };
    //   return texts[this.interpretation];
    // }
  },
  methods:{
    getColor,

    /**Get the answer text for an item*/
    answerText(answerValue){
      console.info(typeof answerValue)
      return this.scale.options.find(opt => opt.score == parseInt(answerValue)).name
    },
  }
}
</script>

<style scoped>
.v-list-item :deep(.v-list-item-title) {
  white-space: normal !important;
  overflow-wrap: break-word !important;
}
</style>